import React from "react";
import { InfoBoxElementType } from "../InfoBoxesModule";
import { InfoBox } from "./InfoBox";
import { InfoboxesOptionsType } from "@/types/ModuleOptionsType";
import { Breakpoint } from "@aleksundshantu/aunds-utils-react/layout";

interface InfoBoxesProps {
  elements: InfoBoxElementType[];
  infoBoxOptions: InfoboxesOptionsType;
  extraClass?: string;
  itemWidth: Record<Breakpoint, string>;
  show_cardbox: boolean;
  show_divider: boolean;
  heading_level: number;
}

export const InfoBoxes = ({
  elements,
  // type,
  infoBoxOptions,
  extraClass,
  itemWidth,
  show_cardbox,
  show_divider,
  heading_level,
}: InfoBoxesProps) => {
  return (
    <div className={`columns is-multiline is-centered`}>
      {elements.map((element, index) => {
        return (
          <InfoBox
            key={index}
            element={element}
            extraClass={`${extraClass}`}
            infoBoxOptions={infoBoxOptions}
            itemWidth={itemWidth}
            show_cardbox={show_cardbox}
            show_divider={show_divider}
            heading_level={heading_level}
          />
        );
      })}
    </div>
  );
};
